import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { suppressAfterDraft } from "@/modules/approval/draft-notice";
//from :https://vue-toastification.maronato.dev/

/**
 * TKP-207 — bildirim süresi iletinin uzunluğuna göre (okuma süresi). Süre verilmeyen bildirim bu işaret değeri taşır
 * (`filterBeforeCreate` varsayılanlarla birleşmiş özellikleri alır; açık süreyi varsayılandan ayırmanın yolu bu); açıkça süre
 * verilen bildirim (ör. giriş hatası 15 sn) kendi süresini korur.
 */
export const AUTO_TIMEOUT = 2001;
export const MIN_TIMEOUT = 4000;
export const MIN_ALERT_TIMEOUT = 6000; // uyarı / hata
export const MAX_TIMEOUT = 15000;

/** Bildirim içeriğinin metni (dize ya da bileşen: `props.message` / `props.text`). */
export const textOf = (content) => {
  if (typeof content === "string") return content;
  if (content && typeof content === "object" && content.props) return String(content.props.message || content.props.text || "");
  return "";
};

/** Okuma süresi: 2,5 sn + karakter başına 70 ms; en az 4 sn (uyarı/hata 6 sn), en çok 15 sn. */
export const readingTimeout = (content, type) => {
  const min = type === "error" || type === "warning" ? MIN_ALERT_TIMEOUT : MIN_TIMEOUT;
  return Math.min(MAX_TIMEOUT, Math.max(min, 2500 + textOf(content).length * 70));
};

export const withReadingTimeout = (toast) => (toast && toast.timeout === AUTO_TIMEOUT ? { ...toast, timeout: readingTimeout(toast.content, toast.type) } : toast);

export default {
  install(Vue, options) {
    Vue.use(Toast, {
      transition: "Vue-Toastification__fade",
      maxToasts: 3,
      newestOnTop: true,
      position: "bottom-right",
      timeout: AUTO_TIMEOUT, // TKP-207: 2 sn uzun iletiyi okumaya yetmiyordu — süre iletiye göre (withReadingTimeout)
      filterBeforeCreate: (toast) => {
        const kept = suppressAfterDraft(toast); // TKP-241 p.4: taslak bildiriminin ardından "başarılı" bildirimi yok
        return kept ? withReadingTimeout(kept) : false;
      },
      closeOnClick: false,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 0.6,
      showCloseButtonOnHover: true,
      hideProgressBar: false,
      closeButton: "button",
      icon: true,
      rtl: false,
      ...options,
    });
  },
};
